import ModelPrototype, { Method } from "@models/ModelPrototype";

export default class NetworkingStats extends ModelPrototype {
  public async get(): Promise<any> {
    try {
      return this.withUrl(`main/networking_stats`).setMethod(Method.GET).request();
    } catch (Exception) {
      throw Exception;
    }
  }
}
